<kendo-combobox [popupSettings]="{appendTo: 'component'}" #entitylist placeholder="Specific Entity"
    [data]="suggestionItems" [filterable]="true" [textField]="'shortName'" [valueField]="'id'"
    [(ngModel)]="selectedItems" (valueChange)="valueChange()" (filterChange)="handleFilter($event)"
    [disabled]="disabled">
    <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
    </ng-template>
</kendo-combobox>